<script setup lang="ts">
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue'

defineProps<{
  modelValue: boolean
  title: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'save'): void
}>()

const save = () => {
  emit('save')
  emit('update:modelValue', false)
}
</script>

<template>
  <TransitionRoot as="template" :show="modelValue">
    <Dialog
      as="div"
      class="z-40 fixed inset-0 overflow-hidden"
      @close="emit('update:modelValue', false)"
    >
      <div class="absolute inset-0 overflow-hidden">
        <DialogOverlay class="absolute inset-0" />

        <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-200 md:duration-500"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transform transition ease-in-out duration-200 md:duration-500"
            leave-from="translate-x-0"
            leave-to="translate-x-full"
          >
            <div class="w-screen max-w-sm">
              <div
                class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
              >
                <div
                  class="min-h-0 flex-1 flex flex-col py-6 overflow-y-scroll"
                >
                  <div class="px-4 md:px-6">
                    <div class="flex items-start justify-between">
                      <DialogTitle
                        class="text-lg m-0 font-medium text-gray-900"
                      >
                        {{ title }}
                      </DialogTitle>
                      <div class="ml-3 flex items-center">
                        <button
                          type="button"
                          class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                          @click="emit('update:modelValue', false)"
                        >
                          <span class="sr-only">Close panel</span>
                          <div
                            class="i-heroicons-solid-x text-md"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mt-6 relative flex-1 px-4 md:px-6">
                    <slot />
                  </div>
                </div>

                <div class="flex-shrink-0 px-4 py-4 flex justify-end">
                  <Button @click="emit('update:modelValue', false)">
                    Cancel
                  </Button>
                  <Button variant="primary" class="ml-2" @click="save">
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
